import template from './drive.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controllerAs: '$ctrl',
  controller: class controller {
    constructor($rootScope, $timeout, $mdDialog, eventService, uiService, driveService) {
      'ngInject';

      const ctrl = this;

      ctrl.initialize = () => {
        ctrl.destroyWatch = eventService.onDriveUploadOrSync((params) => {
          $mdDialog
            .show({
              targetEvent: params?.event || null,
              locals: {
                attachments: params?.attachments || [],
                driveSyncs: params?.driveSyncs || [],
                idAccount: params?.idAccount || '',
                idTicket: params?.idTicket || '',
                driveType: params?.driveType || '',
                title: params?.title || 'Title'
              },
              clickOutsideToClose: false,
              template,
              controllerAs: '$ctrl',
              multiple: true,
              controller(attachments, driveSyncs, idAccount, idTicket, driveType, title) {
                const self = this;
                self.attachments = attachments;
                self.driveSyncs = driveSyncs;
                self.idAccount = idAccount;
                self.idTicket = idTicket;
                self.driveType = driveType;
                self.title = title;
                self.driveTitle = '';
                self.driveIcon = '';

                self.folders = [];
                self.path = [{ id: 'root', name: 'Root', parentId: '', type: 'folder' }];
                self.isNewFolderBeingCreated = false;
                self.folderNewName = '';
                self.errorMessages = [];
                self.hasError = false;
                self.isLoading = true;

                switch (self.driveType) {
                  case 'dropbox':
                    self.driveTitle = 'Dropbox';
                    self.driveIcon = 'dropbox.svg';
                    break;
                  case 'googleDrive':
                    self.driveTitle = 'Google Drive';
                    self.driveIcon = 'googleDrive.svg';
                    break;
                  case 'oneDrive':
                    self.driveTitle = 'One Drive';
                    self.driveIcon = 'oneDrive.svg';
                    break;
                  default:
                    break;
                }

                driveService
                  .listFiles({
                    idOwner: self.idAccount,
                    idFolder: self.path[0].id,
                    driveType: self.driveType
                  })
                  .then((response) => {
                    self.folders = self.driveSort(response?.list || []);
                    self.isLoading = false;
                  });

                self.chooseFolder = (selectedItem, isBreadcrumb) => {
                  if (selectedItem?.type === 'folder') {
                    self.isLoading = true;
                    driveService
                      .listFiles({
                        idOwner: self.idAccount,
                        idFolder: selectedItem.id,
                        driveType: self.driveType
                      })
                      .then((response) => {
                        self.setPath(selectedItem, isBreadcrumb);
                        self.folders = self.driveSort(response?.list || []);
                        self.isLoading = false;
                      });
                  }
                };

                self.appendPath = (selectedItem) => {
                  self.path.push(selectedItem);
                };

                self.setCurrentPath = (selectedItem) => {
                  const selectedItemIndex = _.findIndex(
                    self.path || [],
                    ({ id }) => id === selectedItem?.id
                  );
                  self.path = self.path.slice(0, selectedItemIndex);
                  self.path.push(selectedItem);
                };

                self.setPath = (selectedItem, isBreadcrumb) => {
                  if (isBreadcrumb) {
                    self.setCurrentPath(selectedItem);
                  } else {
                    self.appendPath(selectedItem);
                  }
                };

                self.getFolderName = (name) =>
                  name?.length > 10 ? `${name.substring(0, 10)}...` : name;

                self.createFolder = () => {
                  self.isNewFolderBeingCreated = true;
                };

                self.createNewFolderCancel = () => {
                  self.isNewFolderBeingCreated = false;
                  self.folderNewName = '';
                };

                self.createNewFolderSave = ($event) => {
                  $event.stopPropagation();

                  if (self.folderNewName === '') {
                    return;
                  }

                  self.isNewFolderBeingCreated = false;
                  self.isLoading = true;

                  driveService
                    .createFolder({
                      idOwner: self.idAccount,
                      idFolder: self.currentFolder().id,
                      name: self.folderNewName,
                      driveType: self.driveType
                    })
                    .then((result) => {
                      self.folderNewName = '';
                      if (result?.status) {
                        driveService
                          .listFiles({
                            idOwner: self.idAccount,
                            idFolder: self.currentFolder()?.id,
                            driveType: self.driveType
                          })
                          .then((response) => {
                            self.folders = self.driveSort(response?.list || []);
                            self.isLoading = false;
                          });
                      } else {
                        self.hasError = true;
                        if (result?.errors?.length) {
                          const len = result?.errors?.length || 0;
                          for (let e = 0; e < len; e += 1) {
                            const error = result?.errors[e];
                            const message = error?.label
                              ? `${error?.label?.sanitize()} -> ${error?.message || ''}`
                              : error?.message || error || '';
                            self.errorMessages.push(message);
                          }
                        } else {
                          self.errorMessages.push(result?.errorMessage);
                        }
                        self.errorMessages.unshift(`${self.driveTitle} errors:`);
                        self.isLoading = false;
                        $timeout(() => {
                          self.hasError = false;
                          self.errorMessages = [];
                        }, 5250);
                      }
                    });
                };

                self.deleteFolderOrFile = ({ event, item }) => {
                  event.stopPropagation();
                  driveService
                    .deleteFolderOrFile({
                      idOwner: self.idAccount,
                      idTicket: self.idTicket,
                      id: item.id,
                      driveType: self.driveType
                    })
                    .then((result) => {
                      if (result.status) {
                        self.folders = _.reject(self.folders, (file) => file?.id === item?.id);
                        const idx = _.findIndex(
                          self.driveSyncs || [],
                          (s) => s?.idAccount === self.idAccount && s?.idFolder === item.id
                        );
                        if (idx > -1) {
                          self.driveSyncs.splice(idx, 1);
                        }
                      }
                    });
                };

                self.driveSort = (list) =>
                  list.sort((a, b) => {
                    const nameA = a.name.toUpperCase();
                    const nameB = b.name.toUpperCase();

                    if (a.is_team_folder && !b.is_team_folder) {
                      return -1;
                    }
                    if (!a.is_team_folder && b.is_team_folder) {
                      return 1;
                    }
                    if (a?.type !== 'folder' && b?.type === 'folder') {
                      return 1;
                    }
                    if (a?.type === 'folder' && b?.type !== 'folder') {
                      return -1;
                    }
                    if (nameA < nameB) {
                      return -1;
                    }
                    if (nameA > nameB) {
                      return 1;
                    }

                    return null;
                  });

                self.currentFolder = () => _.last(self.path);

                self.isFolderSynced = (item) => {
                  const currentFolder = _.find(
                    self.driveSyncs || [],
                    (s) => s?.idFolder === (!item ? 'root' : item?.id)
                  );
                  return currentFolder !== undefined;
                };

                self.isReadOnly = (sharingInfo) => sharingInfo && sharingInfo.read_only;

                self.isFolder = (item) => item?.type === 'folder';

                self.setFileType = (item) =>
                  self.isFolder(item) ? 'folder' : 'insert_drive_file';

                self.cancel = () => {
                  $mdDialog.cancel();
                };

                self.confirm = () => {
                  $mdDialog.hide({
                    idOwner: self.idAccount,
                    folder: self.currentFolder(),
                    files: self.attachments,
                    driveType: self.driveType,
                    driveTitle: self.driveTitle
                  });
                };
              }
            })
            .then((result) => {
              if (result?.files?.length) {
                uiService.toast({
                  text: {
                    p1: 'Uploading',
                    p2: `${result?.files?.length} file(s)`,
                    p3: `to ${result?.driveTitle} ...`
                  },
                  progress: true,
                  delay: 2500
                });
                driveService
                  .uploadFiles({
                    idOwner: result?.idOwner,
                    idFolder: result?.folder?.id,
                    files: result?.files,
                    driveType: result?.driveType
                  })
                  .then((response) => {
                    if (response.status) {
                      uiService.toast({
                        text: {
                          p1: 'Uploaded',
                          p2: `${result?.files?.length} file(s)`,
                          p3: `to ${result?.driveTitle}`
                        },
                        success: true
                      });
                    } else {
                      uiService.toast({
                        text: {
                          p1: 'Something went wrong,',
                          p2: `upload to ${result?.driveTitle}`,
                          p3: 'has failed'
                        },
                        warn: true
                      });
                    }
                    ctrl.onFinished({});
                  });
              } else {
                const data = {
                  folder: result?.folder,
                  driveType: result?.driveType,
                  driveTitle: result?.driveTitle
                };
                ctrl.onFinished({ data });
              }
            });
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
